import { render, staticRenderFns } from "./TabProvedor.vue?vue&type=template&id=7b2a8aee&scoped=true"
import script from "./TabProvedor.vue?vue&type=script&lang=js"
export * from "./TabProvedor.vue?vue&type=script&lang=js"
import style0 from "./TabProvedor.vue?vue&type=style&index=0&id=7b2a8aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a8aee",
  null
  
)

export default component.exports